export default "__VITE_ASSET__a736521c__"